import { formatEther } from '@ethersproject/units';
import { useWeb3React } from '@web3-react/core';
import { useContext } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import appContext from '../../../context/app/appContext';
import { sleep } from '../../../web3/utils';

const useClaimablePerformanceFees = () => {
    const { account } = useWeb3React();

    const { interfaceSDK, chainConfig } = useContext(appContext);

    const { mutate: globalMutate } = useSWRConfig();

    const { data, error, mutate } = useSWR(
        interfaceSDK && account ? ['claimablePerformanceFees', account] : null,
        async (_, userAddress) => {
            const stakingContract = interfaceSDK!.get.getSpoolStakingContractInstance();
            const spoolDaiLpEarned = await stakingContract.earned(
                chainConfig['SPOOL-DAI-LP'],
                userAddress
            );
            return formatEther(spoolDaiLpEarned);
        }
    );

    const update = async (previousValue?: string) => {
        if (!previousValue) {
            return mutate(undefined, true);
        }

        let retries = 0;

        do {
            const currentValue = await mutate(undefined, true);

            if (currentValue !== previousValue) {
                break;
            }

            retries++;
            await sleep(3000);
        } while (retries < 5);
        globalMutate(['claimedStakingRewards', account]);
    };

    return {
        claimablePerformanceFees: data,
        isLoading: !error && !data,
        error,
        updateClaimablePerformanceFees: update,
    };
};

export default useClaimablePerformanceFees;
